import React from 'react';
import {Descriptions, DescriptionsProps, Drawer, FloatButton} from 'antd';
import useRequest from '../../../Utils/Hooks/useRequest';
import {getTenantViewInfo} from '../TenantsAll/service';
import {useToggle} from 'react-use';

interface Props {
    id: string;
}
const Index = ({id}: Props) => {
    const [data] = useRequest(() => getTenantViewInfo(id!));
    const [show, toggleShow] = useToggle(false);
    const columns: DescriptionsProps['items'] = [
        {
            label: '方案',
            children: data?.versionName,
        },
        {
            label: '用户数',
            children: `${data?.userNumber}/${data?.maxUserNumber}`,
        },
        {
            label: '主体',
            children: data?.serviceSubject,
        },
        {
            label: '到期时间',
            children: data?.expirationEndTime,
        },
        {
            label: '创建人',
            children: data?.createUser,
        },
        {
            label: '联系人',
            children: data?.contacts,
        },
        {
            label: '租户账号',
            children: data?.adminLoginName,
        },
        {
            label: '联系电话',
            children: data?.phone,
        },
        {
            label: '地址',
            children: data?.locationDetail,
            span: 2,
        },
    ];
    return (
        <div>
            <FloatButton
                description="HELP INFO"
                shape="square"
                onClick={toggleShow}
            />
            <Drawer width={500} open={show} onClose={toggleShow}>
                <Descriptions
                    column={2}
                    title={`${data?.name}  ${data?.code}`}
                    items={columns}
                />
            </Drawer>
        </div>
    );
};

export default Index;
